import { defineStore } from 'pinia'

export const useAuthStore = defineStore('auth', () => {
    const user = ref<UserDto>({})

    const authenticated = ref(false)

    async function authenticateUser (loginRequest: LoginRequest) {
      await $fetch('/api/login?useCookies=true', {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: loginRequest
      })
      authenticated.value = true
    }

    async function registerUser (newUser: RegisterRequest) {
      const errors = await $fetch('/api/register', {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: newUser
      })
      if (errors) throw errors
    }

    async function forgotPassword (email: ForgotPasswordRequest) {
      await $fetch('/api/forgotPassword', {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: email
      })
    }

    async function resetPassword (reset: ResetPasswordRequest) {
      await $fetch('/api/resetPassword', {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: reset
      })
    }

    async function getUserProfile () {
      const data = await $fetch<UserDto>('/api/users/me', {
        method: 'get',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include'
      })

      if (data) {
        user.value = data
      }
    }

    async function updateUserProfile (newUser: RegisterRequest) {
      const data = await $fetch<UserDto>('/api/users/me', {
        method: 'put',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: newUser
      })

      if (data) {
        user.value = data
      }
    }

    async function logUserOut () {
      authenticated.value = false
      user.value = {}

      await $fetch('/api/users/signout', {
        method: 'get',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include'
      }).catch()
      const authCookie = useCookie('nailstv-auth')
      const accessCookie = useCookie('nailstv-access')
      authCookie.value = null
      accessCookie.value = null
    }

    return {
      user,
      authenticated,
      authenticateUser,
      registerUser,
      resetPassword,
      forgotPassword,
      getUserProfile,
      updateUserProfile,
      logUserOut
    }
  },
  {
    persist: {
      key: 'nailstv-auth'
    }
  }
)
